import React, {useEffect, useRef, useState} from "react";
import {
  CancelButton,
  CopyCode,
  Memo,
  RowSpan,
  SaveExcelButton,
  Script,
  Site,
} from "../../assets/GlobalStyles";
import ReactDataGrid from '@inovua/reactdatagrid-enterprise';
import '@inovua/reactdatagrid-enterprise/base.css';
import '../../assets/default-light.scss'
import {useAtom, useSetAtom} from "jotai";
import {modalController} from "../../store";
import {ModalBody, ModalFooter, ModalHeader} from "../modal/Modal";
import {VerticalRule} from "../common/Common";
import {ConvertedMediaComponent} from "../Account/ModalComponents";
import {GuideBody, GuideContainer, GuideHeader, Off, On, PreviewSubmit, ScriptSubject, SwitchBox} from "./styles/common";
import {exportCSV} from "../reports/ExportCSV";

export function SwitchComponent(props){
  const {value, cellProps, eventClick, disabled} = props
  const [select, setSelect] = useState(value)
  const [changing, setChanging] = useState(false)
  const changingRef = useRef(false)
  const [, setModal] = useAtom(modalController)
  const background = !select ? {background: '#ddd'} : {background: 'var(--theme-main)'};
  const position = select ? {left: ' calc(100% - 4px)', transform: 'translateX(-100%)'} : null

  useEffect(() => {
    setSelect(cellProps.data.publishYn === 'Y');
  }, [cellProps.data.publishYn]);

  const handleClick = async (confirm) => {
    if(!confirm){
      setModal({isShow:false});
      return;
    }
    if(changingRef.current) return;
    const nextValue = cellProps.data.publishYn !== 'Y';
    changingRef.current = true;
    setChanging(true);
    const updated = await eventClick(nextValue);
    if(updated){
      cellProps.data.publishYn = nextValue ? 'Y' : 'N';
      setSelect(nextValue);
    }else{
      setSelect(cellProps.data.publishYn === 'Y');
      window.alert('게재 상태 변경에 실패했습니다. 잠시 후 다시 시도해 주세요.');
    }
    changingRef.current = false;
    setChanging(false);
    setModal({isShow:false});
  }
  const showModal = () => {
    setModal({
      isShow: true,
      width: 470,
      modalComponent: () => {
        return (
            <div>
              <ModalHeader title={'지면 게재 상태 변경'} closeBtn={false}/>
              <ModalBody>
                <div>게재 상태를 변경하시겠습니까?</div>
              </ModalBody>
              <ModalFooter>
                <CancelButton onClick={()=>handleClick(false)}>취소</CancelButton>
                <PreviewSubmit onClick={()=>handleClick(true)}>확인</PreviewSubmit>
              </ModalFooter>
            </div>
        )
      }
    })
  }

  return(
    <SwitchBox
      style={background}
      disabled={disabled || changing}
      aria-disabled={disabled || changing}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        if(!disabled && !changing) showModal();
      }}
    >
      <label style={position}/>
      {select ? <On>ON</On>:  <Off>OFF</Off>}
    </SwitchBox>
  )
}


function ScriptComponent(props){
  const {cellProps} = props
  const[, setModal] = useAtom(modalController)
  const handleClick = () => {
    setModal({
      isShow: true,
      width: 1320,
      modalComponent: () => {
        return (
          <div>
            <ModalHeader title={'지면 스크립트 발급 안내'}/>
            <ModalBody>
              <ScriptSubject>
                <div>지면 등록이 완료되었습니다.<br/>
                  하단 발급된 광고 API를
                  <a
                      href="https://www.notion.so/API-2afbe20d845e8002a124c20d307295da?source=copy_link"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{fontWeight: "bold", fontSize: '17px', marginLeft: '10px', color: 'rgb(30, 58, 138)'}}
                  >
                    광고 송출 가이드
                  </a>를 참고하여 표출할 광고 콘텐츠 영역에 삽입해주세요.
                </div>
                <div>※ 발급된 스크립트 정보는 지면 관리에서 확인 가능합니다.</div>
              </ScriptSubject>
              <GuideContainer>
                <GuideHeader>광고 API(JSON) <Icon icon={'copyCode'} value={'https://dsp.oaple.co.kr/audio/ad?mediaScriptNo='+cellProps.data.inventoryId + '&output=json'}/></GuideHeader>
                <GuideBody>
                  <pre>{'https://dsp.oaple.co.kr/audio/ad?mediaScriptNo='+cellProps.data.inventoryId + '&output=json'}</pre>
                </GuideBody>
                <VerticalRule style={{margin: "20px 0"}}/>
                <GuideHeader>광고 API(XML) <Icon icon={'copyCode'} value={'https://dsp.oaple.co.kr/audio/ad?mediaScriptNo='+cellProps.data.inventoryId + '&output=xml'}/></GuideHeader>
                <GuideBody>
                  <pre>{'https://dsp.oaple.co.kr/audio/ad?mediaScriptNo='+cellProps.data.inventoryId + '&output=xml'}</pre>
                </GuideBody>
              </GuideContainer>
              <VerticalRule style={{margin: "20px 0"}}/>
            </ModalBody>
            <ModalFooter>
              <PreviewSubmit onClick={() => setModal({isShow: false})}>확인</PreviewSubmit>
            </ModalFooter>
          </div>
        )
      }
    })
  }
  return(
    <Script onClick={e => {
      e.stopPropagation()
      handleClick()
    }}/>
  )
}

function MemoComponent(props){
  const {cellProps} = props
  const setModal = useSetAtom(modalController)
  function handleMemoClick(){
    setModal({
      isShow: true,
      width: 500,
      modalComponent:() => {
        return <ConvertedMediaComponent data={cellProps} setModal={setModal}/>
      }
    })
  }
  return(
    <Memo onClick={e => {
      e.stopPropagation()
      handleMemoClick()
    }}/>
  )
}

export function Icon(props) {
  const handleCopyClipBoard = async (text) => {
    if(navigator.clipboard){
      navigator.clipboard
        .writeText(text)
        .then(()=>{alert('클립보드에 복사되었습니다.')})
        .catch(()=>{alert('복사를 다시 시도해 주세요.')});
    } else {
      if (!document.queryCommandSupported("copy")) {
        return alert("복사하기가 지원되지 않는 브라우저입니다.");
      }

      // 흐름 3.
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.top = '0';
      textarea.style.left = '0';
      textarea.style.position = "fixed";

      // 흐름 4.
      document.body.appendChild(textarea);
      // focus() -> 사파리 브라우저 서포팅
      textarea.focus();
      // select() -> 사용자가 입력한 내용을 영역을 설정할 때 필요
      textarea.select();
      // 흐름 5.
      document.execCommand("copy");
      // 흐름 6.
      document.body.removeChild(textarea);
      alert("클립보드에 복사되었습니다.");
    }
  };
  return(
    <>
      {props.icon === 'script' &&
        <ScriptComponent cellProps={props.cellProps} />
      }
      {props.icon === 'memo' &&
        <MemoComponent cellProps={props.cellProps.data} />
      }
      {props.icon === 'url' &&
        <a href={props.value} target={'_blank'} rel="noopener noreferrer">
          <Site/>
        </a>
      }
      {props.icon === 'copyCode' &&
        <CopyCode onClick={() => handleCopyClipBoard(props.value)}/>
      }
    </>
  )
}

export const i18n = {
  sortAsc: '오름차순',
  sortDesc: '내림차순',
  unsort:'정렬 해제',
  autoSizeToFit:'크기에 맞게 자동 조정',
  autoresizeThisColumn:'열 자동 조정',
  autoresizeAllColumns:'모든 열 자동 조정',
  columns: '항목 설정',
  pageText: '페이지',
  ofText: '/',
  perPageText: '페이지 당',
  showingText: '페이지',
}

export default function Table (props) {
  const {columns, data, groups, fileName, downloadList } = props
  const [gridRef, setGridRef] = useState(null);
  const gridStyle = {minHeight: 450}

  useEffect(() => {
    if(gridRef){
      gridRef.current.setColumnSizesToFit()
    }
  },[gridRef])

  useEffect(() => {
    if (props.downloadTrigger > 0 && gridRef) {
      exportCSV(gridRef, fileName);
    }
    // 외부 다운로드 버튼이 실행될 때 현재 테이블 데이터를 저장합니다.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.downloadTrigger]);

  const emptyText = <p style={{
    fontSize: 16,
  }}>{props.emptyText !== undefined ? props.emptyText : '데이터가 없습니다.' }</p>
  /**
   * 오른쪽 마우스 클릭 방지
   * @param menuProps
   * @param rowProps
   */
  const renderRowContextMenu = (menuProps, { rowProps }) => {
    menuProps.autoDismiss = true
  }

  const gridElement = (
    <ReactDataGrid
      licenseKey={process.env.REACT_APP_DATA_GRID_LICENSE_KEY}
      idProperty={props.idProperty}
      handle={setGridRef}
      columns={columns}
      dataSource={data}
      headerHeight={48}
      showZebraRows={false}
      showCellBorders={'horizontal'}
      groups={groups !== null ? groups : false}
      enableColumnAutosize={true}
      showColumnMenuLockOptions={false}
      showColumnMenuGroupOptions={false}
      emptyText={emptyText}
      limit={30}
      pagination={props.pagination}
      livePagination={props.livePagination}
      scrollThreshold={props.scrollThreshold}
      style={{
        ...gridStyle,
        ...props.style,
      }}
      showHoverRows={false}
      activeCell={null}
      i18n={i18n}
      renderRowContextMenu={renderRowContextMenu}
      {...props}
    />
  )
  return(
    <>
      {/*엑셀다운 기능 임시 닫음*/}
      {downloadList &&
        <RowSpan style={{justifyContent: 'flex-end'}}>
          <SaveExcelButton onClick={()=>exportCSV(gridRef, fileName)}>엑셀 저장</SaveExcelButton>
        </RowSpan>
      }
      {gridElement}
    </>
  )
}
